var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 12.9999C1.33301 9.90573 2.56217 6.93826 4.7501 4.75034C6.93802 2.56242 9.90548 1.33325 12.9997 1.33325C16.0939 1.33325 19.0613 2.56242 21.2493 4.75034C23.4372 6.93826 24.6663 9.90573 24.6663 12.9999V20.4228C24.6663 21.6595 24.6663 22.2749 24.4826 22.7693C24.3365 23.161 24.1079 23.5168 23.8122 23.8124C23.5166 24.1081 23.1608 24.3367 22.769 24.4828C22.2747 24.6666 21.6578 24.6666 20.4226 24.6666H12.9997C9.90548 24.6666 6.93802 23.4374 4.7501 21.2495C2.56217 19.0616 1.33301 16.0941 1.33301 12.9999Z",
    stroke: "#218B95",
    strokeWidth: 1.45833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11.5417H17.375M13 17.3751H17.375",
    stroke: "#218B95",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.772021700faa59eadbd7353dd8a38d7d.svg";
export { ForwardRef as ReactComponent };